<template>
  <div id="mouse-analyse" style="overflow: hidden">
    <div class="mouseAnalyse-data">
      <div class="mouseAnalyse-data-head">
        <div class="mouseAnalyse-head-title">
          <span class="mouseAnalyse-data-head-container">鼠情图片分析</span>
        </div>

        <div class="mouseAnalyse-head-select">
          <div class="mouseAnalyse-select-device">
            <el-select @change="mouseDeviceChange($event)" v-model="defaultMouseDevice" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in mouseDeviceList"></el-option>
            </el-select>
          </div>

          <div class="mouseAnalyse-select-time">
            <el-date-picker @change="mouseSelectTime" v-model="defaultMouseTime" unlink-panels type="datetimerange" :picker-options="mousePickerOptions" align="right"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="mouseAnalyse-select-btn">
            <el-button type="primary" @click="mouseQueryData()">查询</el-button>
          </div>
        </div>

        <div  class="mouseAnalyse-head-state">
          <div  class="mouseAnalyse-state-container" >
            <el-button type="warning" @click="mouseState" >设备信息</el-button>
            <el-button type="danger" @click="mouseOperation">设备操作</el-button>
          </div>
        </div>
      </div>

      <div class="mouseAnalyse-data-content" style="overflow:auto;">
        <div v-for="(row, index) in sliceList(mousePicLists.slice((mouseCurrentPage-1)*4,mouseCurrentPage*4), 2)" :key="index" class="mouseAnalyse-data-main">
          <div class="mouseAnalyse-content-container">
            <div v-for="(item ,i) in row" class="mouseAnalyse-content-item">
              <div class="mouseAnalyse-item-img">
                <img :src= "item.targetUrl" @error="e => {e.target.src = item.imageUrl}" class="sporeAnalyse-item-imgValue" referrerpolicy="no-referrer"/>
              </div>
              <div class="mouseAnalyse-item-main">
                <div class="mouseAnalyse-item-name">
                  <span class="mouseAnalyse-item-value">设备ID：{{item.deviceId}}</span>
                </div>
                <div class="mouseAnalyse-item-name">
                  <span class="mouseAnalyse-item-value">图像ID：{{item.imgId}}</span>
                </div>
                <div class="mouseAnalyse-item-name">
                  <span class="mouseAnalyse-item-value">创建时间：{{item.createTime}}</span>
                </div>
                <div class="mouseAnalyse-item-result">
                  <span>分析结果：<br/>&#12288{{item.analyseData}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-pagination @current-change="mouseCurrentChange" :current-page="mouseCurrentPage" class="mouseAnalyse-data-bottom"
                        :page-size="4" layout="total, prev, pager, next, jumper" :total="mousePicLists.length">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    name: 'MouseAnalyseData',
    components: {},
    computed: {
      sliceList() {
        return function (data, count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i/count);
              if(arrTemp.length <= index) {
                arrTemp.push([]);
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      }
    },
    data() {
      return {
        mouseDeviceList: [],
        defaultMouseDevice: '',
        defaultMouseTime: [ moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],
        mousePickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        beginTime: '',
        endTime: '',
        mousePicLists:[],
        mouseCurrentPage: 1,
      }
    },

    mounted() {
      //获取用户等级
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      if(authority != 'TENANT_ADMIN') {
        this.getMouseDevice(customerId);//获取鼠情设备
      }
      this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //默认开始时间
      this.endTime = moment().format("YYYY-MM-DD HH:mm:ss");//默认结束时间
    },

    methods: {
      /**
       * 获取鼠情设备
       * @param customerId
       */
      getMouseDevice(customerId) {
        let that = this;
        this.$MeteSoilCommon.getCustomerData(customerId, function (response) {
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].key.toString().indexOf('mouse') > -1) {
              let jsonMouse = JSON.parse(response.data[i].value);
              that.mouseDeviceList.push({"deviceAddr": jsonMouse.name, "deviceName": jsonMouse.name})
            }
          }
          if(that.mouseDeviceList.length > 0) {//虫情设备存在
            that.defaultMouseDevice = that.mouseDeviceList[0].deviceAddr;//默认鼠情设备
            that.mouseDeviceData();//获取鼠情历史数据
          }
        })
      },

      /**
       * 切换鼠情设备
       * @param event
       */
      mouseDeviceChange(event) {
        this.defaultMouseDevice = event;
        this.mousePicLists = [];
      },

      /**
       * 获取选中的时间
       * @param val
       */
      mouseSelectTime(val) {
        if(val == null) { //清空日期
          this.defaultMouseTime = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]; //默认时间
          this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //默认开始时间
          this.endTime = moment().format("YYYY-MM-DD HH:mm:ss");//默认结束时间
        } else {//非清空数据
          this.beginTime = moment(new Date(val[0]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //开始时间
          this.endTime = moment(new Date(val[1]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //结束时间
        }
      },

      /**
       * 查询按钮
       */
      mouseQueryData() {
        if(this.defaultMouseDevice != '') {//存在设备
          this.mouseDeviceData();//获取鼠情历史数据
        }
      },

      /**
       * 获取鼠情历史数据
       */
      mouseDeviceData() {
        this.mousePicLists = [];
        this.mouseCurrentPage = 1;
          let that = this;
        this.$SporePestCommon.getDeviceImg(this.defaultMouseDevice, this.beginTime, this.endTime, function (response) {
          if( response.length > 0) {//存在历史数据
            for(let i = 0; i < response.length; i++) {
              // {"deviceId": "CBD00000083", "imgId": "53112701_20220429102147807_03.jpg", "createTime": "2022-03-22 12:29:16", "imageUrl": "https://c-ssl.duitang.com/uploads/item/202004/30/20200430215308_lsmhn.jpg", "analyseData":"未分析"}
              let json = {};
              json.deviceId = response[i].device_id;
              json.imgId = response[i].img_id;
              json.createTime = response[i].create_time.substring(0, 10) + " " + response[i].create_time.substring(11, 19);
              json.imageUrl = response[i].img_url;
              json.targetUrl = response[i].target_url;
              json.analyseData = '';
              that.mousePicLists.push(json);
              that.mouseImgData(i, response[i].img_id);//根据imgId获取图片分析后图片
            }
          } else { //不存在历史数据
            that.$message({
              showClose: true,
              type: 'warning',
              message: '所选时间段内未查询出数据'
            })
          }
        })
      },

      /**
       * 根据imgId获取图片分析后图片
       * @param i
       * @param imgId
       */
      mouseImgData(i, imgId) {
        // let arr = [
        //   {
        //     "cato": "美国白蛾",
        //     "box": "[0.8063, 0.6149, 0.83258, 0.66633]",
        //     "cnt4mask": "[[[0.82294, 0.61899]], [[0.8155, 0.62893]], [[0.8098, 0.63828]], [[0.8063, 0.6523]], [[0.8155, 0.65405]], [[0.82251, 0.66633]], [[0.82776, 0.64821]], [[0.83215, 0.6336]], [[0.83258, 0.6225]], [[0.82733, 0.6149]]]",
        //     "annotation_type": "manual",
        //     "img_id": "YBQ00000015_20200903180431000_01.jpg"
        //   },
        //   {
        //     "cato": "美国飞蛾",
        //     "box": "[0.8063, 0.6149, 0.83258, 0.66633]",
        //     "cnt4mask": "[[[0.82294, 0.61899]], [[0.8155, 0.62893]], [[0.8098, 0.63828]], [[0.8063, 0.6523]], [[0.8155, 0.65405]], [[0.82251, 0.66633]], [[0.82776, 0.64821]], [[0.83215, 0.6336]], [[0.83258, 0.6225]], [[0.82733, 0.6149]]]",
        //     "annotation_type": "manual",
        //     "img_id": "YBQ00000015_20200903180431000_01.jpg"
        //   },
        //   {
        //     "cato": "美国白蛾",
        //     "box": "[0.8063, 0.6149, 0.83258, 0.66633]",
        //     "cnt4mask": "[[[0.82294, 0.61899]], [[0.8155, 0.62893]], [[0.8098, 0.63828]], [[0.8063, 0.6523]], [[0.8155, 0.65405]], [[0.82251, 0.66633]], [[0.82776, 0.64821]], [[0.83215, 0.6336]], [[0.83258, 0.6225]], [[0.82733, 0.6149]]]",
        //     "annotation_type": "manual",
        //     "img_id": "YBQ00000015_20200903180431000_01.jpg"
        //   }
        // ];

        let obj = {};
        let that = this;

        this.$SporePestCommon.getImgData(imgId, function (response) {
          if(response.length == 0) {//当前图片未分析或者分析为空
            that.mousePicLists[i].analyseData = '未分析';
          } else {//图片已分析
            response.forEach(v => obj[v.cato] = obj[v.cato] === undefined ? 1 : obj[v.cato] + 1);
            let str = "";
            for(let o in obj) {
              str += o + ":" + obj[o] + "；";
            }
            that.mousePicLists[i].analyseData = str;
          }

        })
      },

      /**
       * 切换页数
       * @param currentPage
       */
      mouseCurrentChange(currentPage) {
        this.mouseCurrentPage = currentPage;
      },

      /**
       * 获取鼠情设备状态
       */
      mouseState() {
        this.$stateInfo({
          deviceAddr: this.defaultMouseDevice,
          deviceType: '鼠情',
          click: () => {
            console.log(``)
          }
        })
      },

      /**
       * 远程操作接口
       */
      mouseOperation() {
        this.$operate({
          deviceAddr: this.defaultMouseDevice,
          click: () => {
            console.log(``)
          }
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../less/MouseAnalyseData";
</style>

<style>
  .mouseAnalyse-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/MouseAnalyseData.vue